var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProduct(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 270,
    height: 210,
    viewBox: "0 0 270 210",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_240px",
    "data-name": "240px",
    transform: "translate(1364 -894)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 270,
    height: 210,
    rx: 5,
    transform: "translate(-1364 894)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_64",
    "data-name": "Group 64",
    transform: "translate(-1291 954)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M811.016,783.313H696.584a4.837,4.837,0,0,0-4.831,4.832v80.336a4.838,4.838,0,0,0,4.831,4.832H811.016a4.84,4.84,0,0,0,4.831-4.832V788.144A4.839,4.839,0,0,0,811.016,783.313Zm-114.432,3.54H811.016a1.294,1.294,0,0,1,1.292,1.292v69.931l-26.789-26.788L760.26,856.546l-32.4-32.4-32.566,32.566V788.144A1.294,1.294,0,0,1,696.584,786.853Z",
    transform: "translate(-691.753 -783.313)",
    fill: "#dddfe1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M1074.492,898.63a8.164,8.164,0,1,0-8.164-8.164A8.163,8.163,0,0,0,1074.492,898.63Z",
    transform: "translate(-996.586 -863.871)",
    fill: "#dddfe1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct);
export default __webpack_public_path__ + "static/media/product.ca2b5aeb.svg";
export { ForwardRef as ReactComponent };